/* eslint-disable camelcase */
import axios from 'axios'
import { wmSign } from '../../apiFunction/encrypt'
import { GetTimeStamp } from '../../apiFunction/getDate'
import Cookies from 'js-cookie'

const oauthURL = `${process.env.REACT_APP_OAUTH_URL}`
const randomKey = Cookies.get('random_key')
const header = {
  'Content-Type': 'application/json',
  'Accept-Language': 'en',
  'app-id': process.env.REACT_APP_ID,
  'device-uuid': process.env.REACT_APP_DEVICE_UUID
}

async function GetInfo () {
  const body = {
    request_parameter: {
      random_key: randomKey
    },
    timestamp: GetTimeStamp()
  }

  const sign = wmSign(body)

  const data = {
    sign: sign
  }
  const response = await axios.post(`${oauthURL}/oauth/info`, data, { headers: header })
  return response.data
}

const getMemberAccessToken = () => {
  const memberAccessToken = sessionStorage.getItem('member_access_token') ? sessionStorage.getItem('member_access_token') : localStorage.getItem('member_access_token')
  return memberAccessToken
}

async function Approve (state, clientId) {
  const body = {
    member_access_token: getMemberAccessToken(),
    request_parameter: {
      random_key: randomKey,
      authToken: sessionStorage.getItem('auth_token'),
      client_id: clientId,
      state: state
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const response = await axios.post(`${oauthURL}/oauth/authorize`, data, { headers: header })
  return response.data
}

async function Deny (state, clientId) {
  const body = {
    member_access_token: getMemberAccessToken(),
    request_parameter: {
      random_key: randomKey,
      authToken: sessionStorage.getItem('auth_token'),
      client_id: clientId,
      state: state
    },
    timestamp: GetTimeStamp()
  }
  const sign = wmSign(body)
  const data = {
    sign: sign
  }
  const requestOption = {
    headers: header,
    data: data
  }
  const response = await axios.delete(`${oauthURL}/oauth/authorize`, requestOption)
  return response.data
}

export { GetInfo, Approve, Deny }
